import { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navItems = [
    { label: '热门专题', href: '#index' },
    { label: '精彩视频', href: '#media' },
    { label: '焦点关注', href: '#carousel' },
    { label: '瓜友热评', href: '#comments' },
    { label: '热搜排行', href: '#ranking' },
    { label: '关于我们', href: '#about' },
  ];

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px] max-w-[1280px] mx-auto">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className="flex items-center gap-2 flex-shrink-0 cursor-pointer"
          >
            <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-chat-smile-2-line text-background-50 text-lg"></i>
            </span>
            <span className="text-lg font-heading text-foreground-800 whitespace-nowrap">
              51吃瓜
            </span>
          </a>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-3 py-2 text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 rounded-md whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#app"
              onClick={(e) => handleNavClick(e, '#app')}
              className="px-4 py-2 text-sm text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              下载APP
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-600 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-3 px-4">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="block py-3 text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 border-b border-background-100 last:border-0 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#app"
              onClick={(e) => handleNavClick(e, '#app')}
              className="block mt-3 py-3 text-center text-sm text-background-50 bg-primary-500 rounded-md cursor-pointer"
            >
              下载APP
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}